import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../utils/auth';
import { useTranslation } from 'react-i18next';
import { useCapability } from '../utils/capabilityContext';
import LanguageSwitcher from './LanguageSwitcher';

const TopNavbar = () => {
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const isAdminAuthenticated = Boolean(localStorage.getItem('admin_token'));
  const { currentUser, logout } = useAuth();
  const { refresh: refreshCapabilities } = useCapability();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  React.useEffect(() => {
    setUserMenuOpen(false);
  }, [location.pathname]);

  // 获取页面标题
  const getPageTitle = () => {
    const path = location.pathname;
    
    if (path === '/') {
      return t('dashboard.title');
    } else if (path.startsWith('/reviewed-reports')) {
      return t('dashboard.reviewedReports');
    } else if (path.match(/^\/reports\/\d+\/view$/)) {
      // /reports/:id/view 路径对应已审核报告查看页面
      return t('dashboard.reviewedReports');
    } else if (path.match(/^\/reports\/\d+\/review$/)) {
      // /reports/:id/review 路径对应待审核报告审核页面
      return t('dashboard.pendingReports');
    } else if (path.startsWith('/reports')) {
      return t('dashboard.pendingReports');
    } else if (path.startsWith('/doctors')) {
      return t('dashboard.doctorManagement');
    } else if (path.startsWith('/admin/debug-demo')) {
      return t('debugDemo.title');
    } else if (path.startsWith('/login')) {
      return t('auth.loginTitle');
    } else if (path.startsWith('/admin-login')) {
      return t('dashboard.adminLogin');
    }
    
    return t('dashboard.title');
  };

  const getPageEyebrow = () => {
    if (location.pathname.startsWith('/reports')) {
      return t('dashboard.pendingReports');
    }

    if (location.pathname.startsWith('/reviewed-reports')) {
      return t('dashboard.reviewedReports');
    }

    if (location.pathname.startsWith('/doctors')) {
      return t('dashboard.admin');
    }

    if (location.pathname.startsWith('/admin/debug-demo')) {
      return t('dashboard.admin');
    }

    if (location.pathname.startsWith('/user-center')) {
      return t('dashboard.userCenter');
    }

    return 'AI Clinic';
  };

  const handleDoctorLogout = async () => {
    await logout();
    navigate('/login');
    setUserMenuOpen(false);
  };

  const handleAdminLogout = async () => {
    localStorage.removeItem('admin_token');
    await refreshCapabilities();
    navigate('/');
    setUserMenuOpen(false);
  };

  return (
    <>
      <header className="app-topbar">
        <div className="app-topbar__copy">
          <span className="app-topbar__eyebrow">{getPageEyebrow()}</span>
          <h1 className="app-topbar__title">
            {getPageTitle()}
          </h1>
        </div>

        <div className="app-topbar__actions">
          <LanguageSwitcher />

          {(currentUser || isAdminAuthenticated) && (
            <div className="user-chip">
              <button
                type="button"
                className="user-chip__trigger"
                onClick={() => setUserMenuOpen(!userMenuOpen)}
              >
                <span className="user-chip__avatar">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </span>
                <span>
                  {isAdminAuthenticated ? t('dashboard.admin') : currentUser?.name}
                </span>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d={userMenuOpen ? 'M18 15l-6-6-6 6' : 'M6 9l6 6 6-6'} />
                </svg>
              </button>

              {userMenuOpen && (
                <div className="dropdown-panel">
                  {!isAdminAuthenticated && (
                    <button
                      type="button"
                      className="dropdown-panel__item"
                      onClick={() => {
                        navigate('/user-center');
                        setUserMenuOpen(false);
                      }}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                      </svg>
                      <span>{t('dashboard.userCenter')}</span>
                    </button>
                  )}
                  <button
                    type="button"
                    className="dropdown-panel__item dropdown-panel__item--danger"
                    onClick={isAdminAuthenticated ? handleAdminLogout : handleDoctorLogout}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                      <polyline points="16,17 21,12 16,7" />
                      <line x1="21" y1="12" x2="9" y2="12" />
                    </svg>
                    <span>{t('auth.logout')}</span>
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </header>

      {userMenuOpen && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 8
          }}
          onClick={() => setUserMenuOpen(false)}
        />
      )}
    </>
  );
};

export default TopNavbar;
